import Env from "../Env";
import Request from "./Request";

export default class MyCompanyRequest extends Request {

  static loadMyCompanySettingsR() {
    return Request.loadR(Request.API_COMPANY_LOAD);
  }

  /**
   * @param data
   * @returns {Promise<Response>}
   */
  static saveMyCompanySettings(data) {
    const url = Env.getBackendURL() + 'config/company/save';
    return Request.submitR(url, data);
  }

  /**
   * @param data
   * @returns {Promise<Response>}
   */
  static validatePhone(data) {
    const url = Env.getBackendURL() + 'config/company/validate_phone';
    return Request.submitR(url, data);
  }
}
